/* Jarvis: chat view mode. "clean" (default) hides tool cards, specialist result cards and thinking blocks;
   "technical" shows everything. Stored per browser in localStorage; no backend involved. */
import { useSyncExternalStore } from "react"

export type ViewMode = "clean" | "technical"

const KEY = "hh_chat_view_mode"
const listeners = new Set<() => void>()

function read(): ViewMode {
  try {
    return localStorage.getItem(KEY) === "technical" ? "technical" : "clean"
  } catch {
    return "clean"
  }
}

let current: ViewMode = read()

export function setViewMode(mode: ViewMode): void {
  current = mode
  try {
    localStorage.setItem(KEY, mode)
  } catch {
    /* storage may be unavailable; the mode still applies for this page load */
  }
  listeners.forEach((l) => l())
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

export function useViewMode(): ViewMode {
  return useSyncExternalStore(subscribe, () => current, () => "clean" as ViewMode)
}
